<template>
  <BaseDrawer
    v-if="userLoaded"
    drawerName="whiteboard"
  />
</template>

<script>
import BaseDrawer from '@/components/base/BaseDrawer'
import { mapActions } from 'vuex'

export default {
  name: 'WhiteboardDrawer',

  props: {
  },

  components: {
    BaseDrawer
  },

  data: () => ({
    userLoaded: false
  }),
  async created () {
    await this.requestUserInfo()
    this.userLoaded = true
  },

  computed: {
  },

  methods: {
    ...mapActions(['requestUserInfo', 'requestAllOrganizations'])
  }
}
</script>

<style lang="sass" scoped>
</style>
